export default "__VITE_ASSET__a5453b1d__"